import client from '../client';

export const getWallpaper = (seq) => {
  let param = ''
  if (seq) {
    param = "?seq=" + seq
  }
  return client.get("/api/v2/wallpaper" + param)
}
